import { render, staticRenderFns } from "./Nations.vue?vue&type=template&id=3041044b&scoped=true&"
import script from "./Nations.vue?vue&type=script&lang=js&"
export * from "./Nations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041044b",
  null
  
)

/* custom blocks */
import block0 from "./Nations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports